import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";

import "./Header.css";

const activeStyle = {
  textDecoration: "underline",
};

function Header() {
  return (
    <header role="banner">
      <Navbar className="border-bottom navbar-dark bg-dark" expand="lg">
        <Navbar.Brand className="white-link">
          Northeastern Neurobiology
        </Navbar.Brand>
        <Navbar.Toggle className="border-0" aria-controls="navbar-toggle" />
        <Navbar.Collapse id="navbar-toggle">
          <Nav className="ml-auto" role="nav">
            <NavLink
              className="nav-link white-link"
              exact
              activeStyle={activeStyle}
              to="/"
            >
              Home
            </NavLink>
            <NavLink
              className="nav-link white-link"
              activeStyle={activeStyle}
              to="/tutorial"
            >
              Tutorial
            </NavLink>
            <NavLink
              className="nav-link white-link"
              activeStyle={activeStyle}
              to="/neurosphere"
            >
              Neurosphere Simulator
            </NavLink>
            <NavLink
              className="nav-link white-link"
              activeStyle={activeStyle}
              to="/exercises"
            >
              Lab Exercises
            </NavLink>
            <NavLink
              className="nav-link white-link"
              activeStyle={activeStyle}
              to="/publications"
            >
              Publications
            </NavLink>
            <NavLink
              className="nav-link white-link"
              activeStyle={activeStyle}
              to="/people"
            >
              People
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}

export default withRouter(Header);
